<template>
  <div class="news-list-box inner">
    <ul class="building-fixs news-fixs">
        <li v-for="(item, index) in newsList.info" :key="index">
          <router-link :to="`/joinview?cid=${item.cid}&name=${indexShow.name}`">
            <figure><img :src="item.thumb" alt=""/></figure>
            <div class="building-content">
              <div class="building-time">
                 <b>{{item.create_time | timeFormat('yy')}}</b>
                 <p>
                   <time>{{item.create_time | timeFormat('mm')}}</time>
                   <em>-</em>
                   <time>{{item.create_time | timeFormat('dd')}}</time>
                 </p>
              </div>
              <div class="building-info">
                <strong>{{item.title}}</strong>
                  <p>{{item.description}}</p>
              </div>
              <div class="building-mtime">
                  {{item.create_time | timeFormat('yy')}}年{{item.create_time | timeFormat('mm')}}月{{item.create_time | timeFormat('dd')}}日
              </div>
            </div>
          </router-link>
        </li>
      </ul>
     <div class="news-pagination">
        <el-pagination
          background
          layout="pager"
          :page-size="pagesize"
          :current-page="queryInfo.page"
          @current-change="handleCurrentChange"
          :total="total">
        </el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      total: 0,
      pagesize: 5,
      queryInfo: {
        catid: this.newscid,
        p: 1
      },
      newsList: []
    }
  },
  props: {
    newscid: Number,
    indexShow: Object
  },
  methods: {
    async getData () {
      const { data: res } = await this.$http.get(`/fdata/article_pagelist?catid=${this.queryInfo.catid}&&p=${this.queryInfo.p}&&pagesize=${this.pagesize}`)
      if (res.code === 1) {
        this.newsList = res.data
        this.total = Number(res.data.count)
        console.log(this)
      }
    },
    handleCurrentChange (newPage) {
      this.queryInfo.p = newPage
      this.getData()
    }
  },
  mounted () {
    this.getData()
  }
}
</script>

<style lang="less" scoped>
@import url("@/assets/css/news/index.less");
@import url("@/assets/css/building/index.less");
</style>
